// created by AI

// created by AI: Keep CDN asset constants in a side-effect-free module.
// Importing this file must never initialize the React application entrypoint.
export const CDN_URL = "https://publicassets-cqc8dufecafad5ay.a01.azurefd.net/img"
export const VESSELS_PATH = `vessels`
export const LOGOS_PATH = `logos`
